import { library } from '@fortawesome/fontawesome-svg-core';

import {
  faCode,
  faCodeBranch,
  faFile,
  faGlobeAmericas,
  faInfo,
  faLanguage,
  faPencilAlt,
  faPlusCircle,
  faTrash,
  faUpload,
  faUsers,
  faCopy,
} from '@fortawesome/free-solid-svg-icons';

import { faEdit } from '@fortawesome/free-regular-svg-icons';

library.add(
  faCode,
  faCodeBranch,
  faFile,
  faEdit,
  faGlobeAmericas,
  faInfo,
  faLanguage,
  faPencilAlt,
  faPlusCircle,
  faTrash,
  faUpload,
  faUsers,
  faCopy
);
